(() => {
  const init = (section) => {
    const scrollEl = section.querySelector('.section-comparison-table__mobile-scroll');
    if (!scrollEl) return;

    scrollEl.addEventListener('scroll', () => {
      scrollEl.classList.toggle('is-scrolled', scrollEl.scrollLeft > 0);
    }, { passive: true });
  };

  document.querySelectorAll('.section-comparison-table').forEach(init);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.section-comparison-table');
    if (section) init(section);
  });
})();
